import { queryClient } from 'App';

import { recordReceiptDelivery } from 'lib/helpers/receiptDelivery';
import { COMMUNICATION_LOGS_QUERY_KEY } from 'lib/constants/queries/queryKeys';

/**
 * A receipt went out (or failed) on a channel: update its delivery state so open receipt screens
 * reflect it, and refresh open communication logs so the new row and status show.
 */
export default (data) => {
  if (!data?.transactionId) return;

  recordReceiptDelivery(queryClient, data);
  queryClient.invalidateQueries({ queryKey: [COMMUNICATION_LOGS_QUERY_KEY] });
};
